// @flow
import styled from 'styled-components';

export const Inner = styled.header`
  h1 {
    margin-bottom: 24px;
  }
`;
